import cirrusApiService from '@/taskpane/services/cirrus-api'
import state from '@/taskpane/state/sidebar-state'
import sendItemOpenMessage from '../messages/send-item-open-message'
import MessageArgs from '../messages/message-args'

interface SidebarLoginCompleteArgs extends MessageArgs {
  zynBitJwtToken: string
  zynBitRefreshToken: string
  zynBitEventIdPropertyExists: boolean
}

export default async function sidebarLoginHandler(data: SidebarLoginCompleteArgs) {
  state.sidebarIsAuthenticated = true
  state.cirrusToken = data.zynBitJwtToken
  state.cirrusRefreshToken = data.zynBitRefreshToken

  try {
    const userId = state.getCirrusUserId()
    const orgSettings = await cirrusApiService.getOrgSettings(userId)
    state.processOrgSettings(orgSettings)
  } catch {
    // keep default org settings
  } finally {
    sendItemOpenMessage()
  }
}
